export const DROPDOWN_BACKGROUND = 'dropdown-background';
export const DROPDOWN_BUTTON = 'dropdown-button';
export const DROPDOWN_CONTAINER = 'dropdown-container';
export const DROPDOWN_LIST_ITEM = 'dropdown-list-item';

// Constants for dropdown styles
export const BACKGROUND_OPEN_OPACITY = 0.3;
export const BACKGROUND_ANIMATION_DELAY = 200;
export const BACKGROUND_OPEN_ANIMATION_DURATION = 700;
export const BACKGROUND_CLOSE_ANIMATION_DURATION = 300;
export const MODAL_ANIMATION_DURATION = 200;
export const LIST_ANIMATION_DURATION = 200;
export const LIST_ANIMATION_DELAY = 100;
export const LIST_ANIMATION_STAGGER = 50;
export const LIST_ITEM_OFFSET = '10px';
export const DISABLE_SCROLL_WAIT = BACKGROUND_OPEN_ANIMATION_DURATION + BACKGROUND_ANIMATION_DELAY;
export const ENABLE_SCROLL_WAIT = 500;
export const SCROLL_INTO_VIEW_DELAY = 500;
